import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Twitter({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M13.6173 10.6218L19.9459 3H18.4463L12.9511 9.61788L8.56215 3H3.5L10.137 13.0074L3.5 21H4.99977L10.8028 14.0113L15.4379 21H20.5L13.6169 10.6218H13.6173ZM11.5632 13.0956L10.8907 12.0991L5.54016 4.16971H7.84371L12.1617 10.5689L12.8341 11.5655L18.447 19.8835H16.1434L11.5632 13.096V13.0956Z" fill="currentColor" /></Svg>;
}
export default Twitter;